var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import JetButton from "@/Jetstream/Button";
import { router } from '@inertiajs/react';
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
import AppLayout from "@/Layouts/AppLayout";
import JetLabel from "../../../Jetstream/Label";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
export default function CreatePartial(_a) {
    var intent = _a.intent, stripe_key = _a.stripe_key;
    var route = useRoute(Ziggy);
    var inputStyle = {
        // iconColor: '#c4f0ff',
        // color: '#ff0',
        fontFamily: 'Nunito, ui-sans-serif, system-ui, -apple-system, "system-ui", sans-serif',
        fontSize: '16px',
        fontSmoothing: 'antialiased',
        padding: "10px",
        spacingUnit: '2px',
        borderRadius: '4px',
        lineHeight: '34px',
        // '::placeholder': {
        //   color: '#87BBFD',
        // },
    };
    // const stripe:any = useStripe();
    //
    // const elements:any = useElements();
    //
    // const card = elements.getElement(CardElement);
    //
    // const number = card.create('cardNumber', {
    //     classes: {
    //         base: 'border focus:border-gray-500 focus:outline-none px-3 py-2 rounded-lg shadow-sm w-full',
    //         complete: 'border focus:border-gray-500 focus:outline-none px-3 py-2 rounded-lg shadow-sm w-full',
    //         empty: 'border focus:border-gray-500 focus:outline-none px-3 py-2 rounded-lg shadow-sm w-full',
    //         focus: 'border focus:border-gray-500 focus:outline-none px-3 py-2 rounded-lg shadow-sm w-full',
    //         invalid: 'border focus:border-gray-500 focus:outline-none px-3 py-2 rounded-lg shadow-sm w-full border-red-500',
    //     },
    // });
    //
    // number.mount('#card-number');
    //
    // const expiry = card.create('cardExpiry', {
    //     classes: {
    //         base: 'border focus:border-gray-500 focus:outline-none px-3 py-2 rounded-lg shadow-sm w-full',
    //         complete: 'border focus:border-gray-500 focus:outline-none px-3 py-2 rounded-lg shadow-sm w-full',
    //         empty: 'border focus:border-gray-500 focus:outline-none px-3 py-2 rounded-lg shadow-sm w-full',
    //         focus: 'border focus:border-gray-500 focus:outline-none px-3 py-2 rounded-lg shadow-sm w-full',
    //         invalid: 'border focus:border-gray-500 focus:outline-none px-3 py-2 rounded-lg shadow-sm w-full border-red-500',
    //     },
    // });
    //
    // expiry.mount('#card-expiry');
    //
    // const cvc = card.create('cardCvc', {
    //     classes: {
    //         base: 'border focus:border-gray-500 focus:outline-none px-3 py-2 rounded-lg shadow-sm w-full',
    //         complete: 'border focus:border-gray-500 focus:outline-none px-3 py-2 rounded-lg shadow-sm w-full',
    //         empty: 'border focus:border-gray-500 focus:outline-none px-3 py-2 rounded-lg shadow-sm w-full',
    //         focus: 'border focus:border-gray-500 focus:outline-none px-3 py-2 rounded-lg shadow-sm w-full',
    //         invalid: 'border focus:border-gray-500 focus:outline-none px-3 py-2 rounded-lg shadow-sm w-full border-red-500',
    //     },
    // });
    // cvc.mount('#card-cvc');
    var stripe = useStripe();
    var elements = useElements();
    function addPaymentMethod() {
        return __awaiter(this, void 0, void 0, function () {
            var cardElement, _a, error, paymentMethod;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        cardElement = elements.getElement(CardElement);
                        return [4 /*yield*/, stripe.createPaymentMethod({
                                type: 'card',
                                card: cardElement,
                            })];
                    case 1:
                        _a = _b.sent(), error = _a.error, paymentMethod = _a.paymentMethod;
                        if (error) {
                            console.log('[error]', error);
                        }
                        else {
                            console.log('[PaymentMethod]', paymentMethod);
                        }
                        if (!error) {
                            router.post(route('billing-portal.payment-method.store'), { token: paymentMethod.id });
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    return _jsxs(AppLayout, __assign({ title: "Billing", pageTitle: "Billing" }, { children: [_jsxs("h2", __assign({ className: "font-semibold text-xl text-gray-800 leading-tight" }, { children: [_jsx("button", __assign({ onClick: function () { return router.visit(route('billing-portal.payment-method.index')); }, className: "focus:outline-none mr-1" }, { children: "\u2190" })), "Billing: Add Payment Method"] })), _jsx("div", __assign({ className: "py-12" }, { children: _jsxs("div", __assign({ className: "max-w-xl mx-auto sm:px-6 lg:px-8" }, { children: [_jsx("div", __assign({ className: "flex flex-col break-words bg-white border rounded-lg shadow-md mb-4" }, { children: _jsxs("div", __assign({ className: "w-full p-6" }, { children: [_jsxs("div", __assign({ className: "flex flex-wrap mb-6" }, { children: [_jsx(JetLabel, { htmlFor: "name", value: "Card Holder Name" }), _jsx("input", { "v-model": "name", type: "text", className: "border border-gray-300 focus:outline-none px-3 py-2 rounded-lg shadow-sm w-full text-xs", required: true, autoComplete: "name" })] })), _jsx("div", __assign({ className: "flex flex-wrap mb-6 space-y-6 md:space-y-0" }, { children: _jsx("div", __assign({ className: "w-full" }, { children: _jsx("div", __assign({ className: "pl-2 border border-gray-300 focus:border-sky-300 focus:ring focus:ring-sky-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full" }, { children: _jsx(CardElement, { options: { style: { base: inputStyle } } }) })) })) })), _jsx(JetButton, __assign({ "data-secret": "intent.client_secret", onClick: function () { return addPaymentMethod(); } }, { children: "Add Payment Method" }))] })) })), _jsxs("div", __assign({ className: "text-center" }, { children: ["Powered by", _jsx("a", __assign({ href: "https://stripe.com", target: "_blank" }, { children: _jsx("img", { src: "/images/stripe_blurple.svg", className: "w-32 h-auto inline ml-1" }) }))] }))] })) }))] }));
}
